module.exports = __webpack_public_path__ + "img/img19.959391bb.png";